import { FC, ReactNode, useRef } from 'react';
import { createPlaySoundFunction, wobbleAnimate } from '../helpers';
import btnClickSound from 'static/assets/audio/btnclick.ogg';
import { getDotsIcon, getGameIcon, getTrophyIcon } from 'static/assets/icons';
import { twMerge } from 'tailwind-merge';

export type TabMenuProps = {
  mainButtonText: string;
  mainButtonClass?: string;
  onMainClick?: () => void;
  icon?: ReactNode;
};

export const TabMenu: FC<TabMenuProps> = ({ mainButtonText, mainButtonClass = 'bg-tertiary border-white', onMainClick, icon }) => {
  const playClickSound = useRef(createPlaySoundFunction(btnClickSound)).current;

  const buttonClasses = 'py-3 flex-1 w-full flex flex-col items-center gap-1 select-none text-sm';

  const handleOnClick = (e: any) => {
    playClickSound();
    wobbleAnimate(e);
  };

  const handleMainClick = (e: any) => {
    handleOnClick(e);
    onMainClick?.();
  };

  return (
    <div className="w-full fixed h-[88px] bottom-0">
      <div className="absolute h-[120%] w-[120%] bottom-[-24px] left-0 -rotate-[2.5deg] bg-primary -z-10" />
      <div className="h-full w-[70%] flex flex-row text-center items-end justify-evenly">
        <button onClick={handleOnClick} className={twMerge(buttonClasses, 'gap-0 pl-4')}>
          {getDotsIcon('36px', 'mb-[-6px]')}
          Mere
        </button>

        <button onClick={handleOnClick} className={buttonClasses}>
          {getGameIcon()}
          Spil
        </button>

        <button onClick={handleOnClick} className={buttonClasses}>
          {getTrophyIcon()}
          Rangliste
        </button>
      </div>

      <button
        onClick={handleMainClick}
        className={twMerge(
          'w-24 h-24 absolute z-10 right-4 bottom-3 bg-tertiary border-solid border-2 border-white rounded-full flex flex-col gap-1 justify-center items-center',
          mainButtonClass
        )}
      >
        {icon}
        {mainButtonText}
      </button>
    </div>
  );
};
